"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserFromJWT = void 0;
const tslib_1 = require("tslib");
const jwt_decode_1 = (0, tslib_1.__importDefault)(require("jwt-decode"));
/**
 * Retrieve a user name (sub key) from an encoded jwt.
 * @param jwt the token to decode
 */
function getUserFromJWT(jwt) {
    try {
        const token = (0, jwt_decode_1.default)(jwt);
        return token.sub;
    }
    catch (e) {
        throw new Error(`Failed to parse jwt! User cannot be obtained: ${e}`);
    }
}
exports.getUserFromJWT = getUserFromJWT;
